import axios from 'axios';
import apiConfig from "../configs/apiConfig";
import qs from 'qs';
import { Children } from 'react';
import { FreezeUI, UnfreezeUI } from '../assets/js/freeze-ui';



function commonApiFunction(params, callback, callbackError = (err) => console.error('Default Error Handler:', err)) {
  // console.log(params, "params >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  axios.post(apiConfig.api_url, qs.stringify(params), { timeout: 30000 })
    .then((response) => {

      //console.log('UnFreezing the Display --> ', params)
      UnfreezeUI()

      callback(response);

    }).catch((error) => {

      //console.log('UnFreezing the Display --> ')
      UnfreezeUI()

      //console.log(error)

      //callbackError(error);

    })
}

export function  commonreportpostApiFunction(methodname,params, callback, callbackError = (err) => console.error('Default Error Handler:', err)) {
  FreezeUI({ text: "Loading...", selector: 'body' });
  axios.post(
      apiConfig.reportapi_url+methodname, qs.stringify(params), 
      {headers: {
          'Authorization': `Bearer ${params.token}`,
      }}
      )
      .then((response) => {
          UnfreezeUI()
          callback(response);

      }).catch((error) => {
          UnfreezeUI()
          callbackError(error);

      })
}

export function commonloginApiFunction(methodname, params, callback, callbackError = (err) => console.error('Default Error Handler:', err)) {
  /// console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });



  axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params), { timeout: 30000 })
    .then((response) => {

      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      callback(response);

    }).catch((error) => {

      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      callbackError(error);

    })
}

// export function  commonpostApiFunction(methodname,params,  callback, callbackError) {
//         axios.post(apiConfig.slimapi_url+methodname, qs.stringify(params), { timeout: 30000})
//             .then((response) => {

//                 callback(response);

//             }).catch((error) => {

//                 callbackError(error);

//             })
//     }

// export function  commongetApiFunction(methodname,params,  callback, callbackError) {
// axios.get(apiConfig.slimapi_url+methodname, qs.stringify(params), { timeout: 30000})
//         .then((response) => {
//         callback(response);
//         }).catch((error) => {
//         callbackError(error);
//         })
// }

export function commonpostApiFunction(methodname, params, callback, callbackError = (err) => console.error('Default Error Handler:', err)) {


  // console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });


  axios.post(
    apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {

      callback(response);
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()

    }).catch((error) => {

      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      callbackError(error);

    })
}

export function commongetApiFunction(methodname, params, callback, callbackError = (err) => console.error('Default Error Handler:', err)) {
  //console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  axios.get(
    apiConfig.slimapi_url + methodname,
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      callback(response);

    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      callbackError(error);

    })
}

export function extraParamApiFunctionRest(methodname, params, callback, variable) {
  //console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  //  console.log(params.token)
  axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // console.log(variable)
      callback(response, variable);
    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // callbackError(error);
    })
}

export function MultiParamReturnApiFunctionRest(methodname, params, callback, variable1, variable2) {
  // console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  //  console.log(params.token)
  axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // console.log(variable)
      callback(response, variable1, variable2);
    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // callbackError(error);
    })
}

/// Added for FAX Variables
export function MultiParamReturnApiFunctionRest2(methodname, params, callback, variable1, variable2, variable3, variable4, variable5, variable6, variable7, variable8, variable9) {
  // console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  //  console.log(params.token)
  axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // console.log(variable)
      callback(response, variable1, variable2, variable3, variable4, variable5, variable6, variable7, variable8, variable9);
    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // callbackError(error);
    })
}

export function MultiParamReturnApiFunctionRest4(methodname, params, callback, variable1, variable2, variable3, variable4) {
  //console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });

  //  console.log(params.token)
  axios.post(apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // console.log(variable)
      callback(response, variable1, variable2, variable3, variable4);
    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      // callbackError(error);
    })
}

export function uploadImageFileFunctionRest(methodname, formData, callback, token) {
  // console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });


  axios.post(apiConfig.slimapi_url + methodname, formData, {
    headers: {
      'content-type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`,
    }
  }).then((response) => {
    callback(response);
    //console.log('UnFreezing the Display --> ', methodname)
    UnfreezeUI()
  }).catch(error => {
    //console.log('UnFreezing the Display --> ', methodname)
    UnfreezeUI()
    //console.log(error)
  })


}
export const VariableReturnpostApiFunction = async (methodname, params) => {

  var result = [];
  // console.log(methodname, "methodname >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });


  await axios.post(
    apiConfig.slimapi_url + methodname, qs.stringify(params),
    {
      headers: {
        'Authorization': `Bearer ${params.token}`,
      }
    }
  )
    .then((response) => {

      result = response;
      //callback(response);
      //console.log('UnFreezing the Display --> ', result)
      UnfreezeUI()

    }).catch((error) => {

      //console.log('UnFreezing the Display --> ', methodname)
      UnfreezeUI()
      //callbackError(error);

    })
  return result;
}

/*   export function uploadImageFileFunctionRest(methodname, formData, callback){
   axios.post(apiConfig.slimapi_url+methodname, formData, {
       headers: {
         'content-type': 'multipart/form-data'
       }
     }).then((response) => {
      callback(response);
       }).catch(error => console.log(error))
 
 
    } */

function extraParamApiFunction(params, callback, variable) {
  //console.log(params, "params >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });


  //  console.log(variable)
  axios.post(apiConfig.api_url, qs.stringify(params), { timeout: 30000 })
    .then((response) => {
      //console.log('UnFreezing the Display --> ', params)
      UnfreezeUI()
      callback(response, variable);
    }).catch((error) => {
      //console.log('UnFreezing the Display --> ', params)
      UnfreezeUI()
      //console.log(error)
      // callbackError(error);
    })
}

function uploadImageFileFunction(formData, callback) {
  // console.log(formData, "fromData >>>")
  FreezeUI({ text: "Loading...", selector: 'body' });


  // let fd = new FormData();
  // fd.append('file', file);
  // fd.append('action', action);

  axios({
    method: 'post',
    url: apiConfig.api_url,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then((response) => {
      //console.log('UnFreezing the Display --> ', formData)
      UnfreezeUI()
      callback(response);
    }).catch(error => {
      //console.log(error)
      //console.log('UnFreezing the Display --> ', formData)
      UnfreezeUI()
    })

}

export { uploadImageFileFunction, extraParamApiFunction }
export default commonApiFunction